import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError,delay } from 'rxjs/operators';
import { Payment } from '../types/payment';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient,private env: EnvService ) { }

  getMaxId() :Observable <any[]>{
    return this.http.get<any[]>(`${this.env.apiUrl}/payments/getMaxId`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

  getAll():Observable <Payment[]> {
   return this.http.get <Payment[]>(`${this.env.apiUrl}/payments`,httpOptions)
   .pipe(catchError(this.handleError));
      
   }

   getPayment(voucherNo):Observable <Payment> {
     return this.http.get<Payment>(`${this.env.apiUrl}/payments/${voucherNo}`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }



   addPayment(data):Observable <any>{
     return this.http.post<any>(`${this.env.apiUrl}/payments`, data,httpOptions)
       .pipe(catchError(this.handleError));
      
   }

   deletePayment(data,voucherNo):Observable <any>{
     return this.http.post<any>(`${this.env.apiUrl}/payments/${voucherNo}`, data,httpOptions)
       .pipe(catchError(this.handleError));
      
   }

   private handleError(errorResponse: HttpErrorResponse) {
    return throwError(errorResponse || "Server Error");

     }       



}
